import { useEffect } from 'react';

export default function Logout() {

  async function logout() {
    window.close();
  }
  useEffect(() => {
    logout();
  }, []);
  return null;
}